import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { FormFields } from '../../AccountForm.meta';
import { OwnerTypeDTO } from '../../../../../../api/useAccountsQuery';
import { selectCurrentClient } from '../../../../../../../../CommonSelectors/CommonAreaSelector';
import { useAccountFormContext } from '../../context/useAccountFormContext';

interface OptionsDTO {
  label: string;
  value: number;
  rightLabel: string | null;
}

export const useAnnuityRiders = () => {
  const { watch } = useFormContext<FormFields>();

  const {
    options: { AnnuityLifeExpectancyPrincipal, AnnuityLifeExpectancySpouse },
  } = useAccountFormContext();

  const [ownerModel, purchaseYear] = watch([
    'bankAccount.OwnerModel',
    'bankAccount.AnnuityPurchaseYear',
  ]);

  const selectedOwnerType = ownerModel.length === 1 && ownerModel[0].OwnerType;

  const isOwnerSpouse = selectedOwnerType === OwnerTypeDTO.Spouse;

  const allData = useSelector(selectCurrentClient);

  const { Dob: primaryDob, PartnerDob: spouseDob } = allData;

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;

  const ownerYob = isOwnerSpouse ? spouseYob : primaryYob;
  const ownerLE = isOwnerSpouse ? AnnuityLifeExpectancySpouse : AnnuityLifeExpectancyPrincipal;

  const getYearFromAge = (yearOfBirth: number | null, age: number | null) => {
    return yearOfBirth && age ? `Year ${yearOfBirth + age}` : null;
  };

  const getBaseIncomeStartYearOptions = (yob: number | null, lifeExpectancy: number) => {
    const currentYear = new Date().getFullYear();
    const startAge = yob ? (purchaseYear ? purchaseYear - yob : currentYear - yob) : 0;
    const ageRange = lifeExpectancy - startAge;
    return Array.from({ length: ageRange + 1 }).map((_, index) => {
      const currentAge = startAge + index;
      return {
        label: currentAge.toString(),
        value: currentAge,
        rightLabel: getYearFromAge(yob, currentAge),
      };
    });
  };

  const baseIncomeStartYearOptions = getBaseIncomeStartYearOptions(ownerYob, ownerLE);

  const incomeStartYearOptions: OptionsDTO[] = [
    {
      label: 'At Retirement',
      value: -1,
      rightLabel: null,
    },
    ...baseIncomeStartYearOptions,
  ];

  return { incomeStartYearOptions };
};
